document.addEventListener('click', async function (e) {
    const btnModalEditarCargo = e.target.closest('#btnModalEditarCargo');
    if (!btnModalEditarCargo) return;

    const idCargo    = btnModalEditarCargo.getAttribute("data-id");
    const formEditar = document.querySelector("#formEditarCargo");
    const modalEditar = document.querySelector("#ModalEditarCargo");

    if (!formEditar || !idCargo || !modalEditar) {
        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta("Faltan parámetros para editar el cargo.", "alerta-roja");
        }
        return;
    }

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        redirect: "follow",
    };

    const url = `/api/configuracion/cargos/infoCargo?idCargo=${idCargo}`;

    try {
        const response = await fetch(url, requestOptions);

        if (!response.ok) {
            throw new Error(`Error HTTP: ${response.status}`);
        }

        const result = await response.json();
        const data   = result.result[0];

        if (!data) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("No se encontró información del cargo.", "alerta-roja");
            }
            setTimeout(() => { window.location.reload(); }, 1500);
            return;
        }

        modalEditar.classList.add('modal--show');

        const inputIdCargo    = formEditar.querySelector('#idCargoEditar');
        const inputNombreCargo = formEditar.querySelector('#nombreCargoEditarDisplay');
        const divShitch       = formEditar.querySelector('#divShitchCargo');

        if (inputIdCargo)     inputIdCargo.value     = data.idCargo     || "";
        if (inputNombreCargo) inputNombreCargo.value = data.nombreCargo || "";

        const checked     = Number(data.estadoCargo) === 1 ? 'checked' : '';
        const textoEstado = Number(data.estadoCargo) === 1 ? 'ACTIVO' : 'INACTIVO';

        divShitch.innerHTML = `
            <span class="labelInfo">Estado:</span>
            <label class="switchEstado">
                <input
                    id="estado"
                    type="checkbox"
                    name="estadoCargo"
                    value="${data.estadoCargo}"
                    ${checked}
                >
                <span class="sliderEstado"></span>
                <span class="textoEstado">${textoEstado}</span>
            </label>
        `;

    } catch (error) {
        console.error("Error al obtener información del cargo:", error);
        if (typeof lanzarAlerta === "function") {
            lanzarAlerta("No se pudo cargar la información del cargo.", "alerta-roja");
        }
    }
});

document.addEventListener('submit', async (e) => {
    if (e.target.id === 'formEditarCargo') {
        e.preventDefault();
        const formulario = e.target;
        const btnSubmit  = formulario.querySelector('#btnEditarCargo');
        const spinner    = formulario.querySelector('#spinner');
        const formData   = new FormData(formulario);
        if (!formulario || !btnSubmit || !spinner) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Faltan parámetros para editar el cargo.", "alerta-roja");
            }
            return;
        }
        btnSubmit.disabled = true;
        spinner.style.display = 'inline-block';
        try {
            const respuesta = await fetch('/api/configuracion/cargos/editar', {
                method: 'POST',
                body: formData
            });
            const json      = await respuesta.json();
            const status    = respuesta.status;
            const resultado = json.result;

            if (status !== 200) {
                alert("Error crítico al procesar la solicitud.");
                setTimeout(() => { window.location.reload(); }, 1500);
                return;
            }

            if (resultado.hayErrores) {
                resultado.errores.forEach(error => {
                    lanzarAlerta(error.mensaje, error.clase);
                    const campo = formulario.querySelector(`[name="${error.campo}"]`);
                    if (campo) campo.classList.add('inputRojo');
                });
                btnSubmit.disabled = false;
                spinner.style.display = 'none';
            }
            if (!resultado.hayErrores) {
                lanzarAlerta("Cargo editado correctamente.", "alerta-verde");
                setTimeout(() => { window.location.reload(); }, 800);
            }

        } catch (error) {
            console.error("Error:", error);
            btnSubmit.disabled = false;
            spinner.style.display = 'none';
        }
    }
});
